import axios from "axios";

export default {
  namespaced: true,
  state: {
    posts: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    postsMessage: ''
  },
  mutations: {
    CLEAR_MARKETPOSTS(state) {
      state.posts = [];
    },
    RECEIVED_MARKETPOSTS(state, payload) {
      state.posts = payload;
      state.isReceiving = false;
    },
    RECEIVING_MARKETPOSTS(state) {
      state.isReceiving = true;
    },
    RECEIVED_MARKETPOST(state, payload) {
      state = Object.assign(state, {
        posts: [...state.posts, payload],
        isReceiving: false,
      })
    },
    RECEIVING_MARKETPOST(state) {
      state.isReceiving = true;
    },
    UPDATED_MARKETPOST(state, payload) {
      let index = state.posts.findIndex(campaign => campaign._id === payload._id);
      state = Object.assign(state, {
        posts: state.posts.map((campaign, i) => {
          if (i === index) {
            return Object.assign({}, campaign, payload);
          }
          return campaign;
        }),
        isUpdating: false,
        postsMessage: 'MarketPosts has been updating!',
      })
    },
    UPDATING_MARKETPOST(state) {
      state.isUpdating = true;
    },
    DELETED_MARKETPOST(state, payload) {
      console.log(payload._id);
      let indexToDelete = state.posts.findIndex(campaign => campaign._id === payload._id);
      console.log(indexToDelete);
      let posts = [...state.posts];
      posts.splice(indexToDelete, 1);
      state = Object.assign(state, {
        posts: [...posts],
        isDeleting: false,
        idToDelete: null,
        postsMessage: 'MarketPost has been Deleted!',
      });
    },
    DELETING_MARKETPOST(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    async deleteMarketPostRequest({dispatch}, payload) {
      dispatch("deletingMarketPost", payload);
      let token = localStorage.getItem('token')
      let url = 'https://api.tradexc.com:3000/delete/marketpost/' + payload._id;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      return axios({method: "delete", url: url, headers: headers})
      .then(response=>{
        console.log(response.data);
        dispatch("deleteMarketPost", response.data);
      })
      .catch(error=>{
        console.log(error.data);
      });
    },
    async deleteProjectPostRequest({dispatch}, payload) {
      try{
        dispatch("deletingMarketPost", payload);
        let token = localStorage.getItem("token");
        let url ="https://api.tradexc.com:3000/delete/marketpost/" + payload._id;
        let headers = {"Content-Type": "application/json",Authorization: "Bearer " + token,};
  
        let response = await axios({ method: "delete", url: url, headers: headers });
        dispatch("deleteMarketPost", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async insertMarketPostRequest({dispatch}, payload) {
      dispatch("receivingMarketPosts");
      var token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/insert/marketpost/' + payload.contentid;
      console.log(url);
      console.log(payload);
      console.log(token)
      delete payload['_id'];
      let data = payload;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};      
      let response = await axios({method: "post", url: url, headers: headers, data: data});
      dispatch("receiveMarketPost", response.data);
      return response.data;
    },
    async insertMarketPostManualRequest({dispatch}, payload) {
      dispatch("receivingMarketPosts");
      var token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/insert/marketpost/manual/' + payload.projectid;
      delete payload['projectid'];
      let data = payload;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      
      let response = await axios({method: "post", url: url, headers: headers, data: data});
      dispatch("receiveMarketPost", response.data);
      return response.data;
    },
    async insertProjectCampaignRequest({dispatch}, payload) {
      try{
        console.log(payload);
        dispatch("receivingMarketPost");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/insert/marketpost/' + payload.projectid;
        let response = await axios({method: "POST", url: url, headers: headers, data: payload});
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async insertProjectCampaignWithImageRequest({dispatch}, payload) {
      try{
        dispatch("receivingMarketPost");
        let token = localStorage.getItem('token');
        let url = 'https://api.tradexc.com:3000/insert/marketpost/withimage/' + payload.projectid;
        let data = new FormData();
        let headers = {'Content-Type': 'multipart/form-data','Authorization': 'Bearer ' + token};
  
        data.append('file', payload.imagefile, payload.imagename); 
        delete payload['imagefile'];
        for (let x in payload) data.append(x, payload[x]);
        
        let response = await axios({method: "post", url: url, headers: headers , data: data});
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async getMarketPostsRequest({dispatch}) {
      dispatch("receivingMarketPosts");
      let token = localStorage.getItem('token');
      console.log(token)
      let url = 'https://api.tradexc.com:3000/get/marketposts';
      let header = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};
      return axios({method: "get", url: url, headers: header})
      .then(response => {
        console.log(response.data);
        dispatch("receiveMarketPosts", response.data);
      })
    },
    async getMarketPostQueryRequest({dispatch}, payload) {
      try{
        dispatch("receivingMarketPosts");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/get/posts/byquery';
        let response = await axios({method: "POST", url: url, headers: headers, data: payload});
        dispatch("receiveMarketPosts", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async updateMarketPostRequest({dispatch}, payload) {
      dispatch("updatingMarketPost");
      let id = payload._id;
      delete payload['_id'];
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/update/marketpost/' + id;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      return axios({method: "put", url: url, headers: headers, data: payload})
      .then((response)=> {
        dispatch("updateMarketPost", response.data);
      })
      .catch((error) => {
        this.alertmessage = error.response.data.error;
      });
    },
    async updateProjectCampaignRequest({dispatch}, payload) {
      try{
        dispatch("updatingMarketPost");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/update/marketpost/' + payload.campaignid;
        let response = await axios({method: "PUT", url: url, headers: headers, data: payload});
        dispatch("updateMarketPost", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async updateProjectCampaignWithImageRequest({dispatch}, payload) {
      try{
        dispatch("updatingMarketPost");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'multipart/form-data','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/update/marketpost/withimage/' + payload.campaignid;

        let data = new FormData();  
        data.append('file', payload.imagefile, payload.imagename); 
        delete payload['imagefile'];
        for (let x in payload) data.append(x, payload[x]);

        let response = await axios({method: "PUT", url: url, headers: headers, data: data});
        dispatch("updateMarketPost", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async updateMarketPostImageRequest({dispatch}, payload) {
      dispatch("updatingMarketPost");
      let token = localStorage.getItem('token');
      let id = payload._id;
      delete payload['_id'];
      let url = 'https://api.tradexc.com:3000/update/marketpost/image/' + id;
      let data = new FormData();
      data.append('file', payload.imagefile, payload.imagename); 
      delete payload['imagefile'];
      for (let x in payload) data.append(x, payload[x])
      let headers = {'Content-Type': 'multipart/form-data','Authorization': 'Bearer ' + token};
      return axios({method: "PUT", url: url, headers: headers, data: data})
      .then(response=>{
        dispatch("updateMarketPost", response.data);
      })
      .catch((error) => {
        this.alertmessage = error;
      });
    },
    clearMarketPosts({commit}) {
      commit("CLEAR_MARKETPOSTS")
    },
    receiveMarketPosts({commit}, payload) {
      commit("RECEIVED_MARKETPOSTS", payload)
    },
    receivingMarketPosts({commit}) {
      commit("RECEIVING_MARKETPOSTS")
    },
    receiveMarketPost({commit}, payload) {
      commit("RECEIVED_MARKETPOST", payload)
    },
    receivingMarketPost({commit}) {
      commit("RECEIVING_MARKETPOST")
    },
    updateMarketPost({commit}, payload) {
      commit("UPDATED_MARKETPOST", payload)
    },
    updatingMarketPost({commit}) {
      commit("UPDATING_MARKETPOST")
    },
    deleteMarketPost({commit}, payload) {
      commit("DELETED_MARKETPOST", payload)
    },
    deletingMarketPost({commit}, payload) {
      commit("DELETING_MARKETPOST", payload)
    }
  },
};
